import React, { useState, useEffect } from "react";
import {
  Avatar,
  Box,
  Button,
  getColor,
  InputField,
  Modal,
  Typography,
  useToast,
} from "fds";
import "../index.scss";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
import utilsCommon from "../../../shared/utils/common";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import { Member } from "../../../types/workgroup";
import classNames from "classnames";
import { t } from "i18next";
import { nanoid } from "@reduxjs/toolkit";
import useLoginStore from "../../../redux/dispatcher/useLoginStore";
interface ProfileTabProps {
  open: boolean;
}

const ProfileTab: React.FC<ProfileTabProps> = ({ open }) => {
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const myId = loginDto?.userInfo?.userId ?? "";

  /** hook 정리 */
  const { workgroupState, getMembersProfile, deleteMember, changeMemberInfo } =
    useWorkgroupStore();
  const { sessionLogout } = useLoginStore();

  const toast = useToast();
  /** State 정리 */
  const [userInfo, changeUserInfo] = useState<Member>(); // 사용자 정보
  const [tempUserInfo, changeTempUserInfo] = useState<Member>(); // 사용자 새 정보
  const [mode, changeMode] = useState<"VIEW" | "EDIT">("VIEW"); // 현재 프로필 타입
  const [extraModal, changeExtraModal] = useState("CLOSE");

  /** UseEffect 정리 */
  useEffect(() => {
    if (workgroupState.memberProfile) {
      changeUserInfo(workgroupState.memberProfile[0].userInfo);
      changeTempUserInfo(workgroupState.memberProfile[0].userInfo);
    }
  }, [workgroupState.memberProfile]);

  /** 함수 정리 */
  /** UI: 프로필 보기 화면 */
  const renderViewpage = () => {
    return (
      <Box direction="column">
        {userInfo?.userType === 2 && (
          <Box alignItems="center">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("login.login.userId")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
            >
              {userInfo?.userId ?? ""}
            </Typography>
          </Box>
        )}
        <Box
          alignItems="center"
          classes={classNames({ "mg mt-24": userInfo?.userType === 2 })}
        >
          <Typography
            type="subtitle2"
            width="120px"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("header.profile.name")}
          </Typography>
          <Typography
            type="body2_rg"
            width={"calc(100% - 130px)"}
            classes="mg ml-10"
            wordBreak="break-word"
          >
            {userInfo?.userName ?? ""}
          </Typography>
        </Box>
        <Box alignItems="center" classes="mg mt-24">
          <Typography
            type="subtitle2"
            width="120px"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {userInfo?.userType === 1
              ? t("signup.company")
              : t("header.profile.involvedComany")}
          </Typography>
          <Typography
            type="body2_rg"
            width={"calc(100% - 130px)"}
            classes="mg ml-10"
            wordBreak="break-word"
          >
            {userInfo?.userType === 1
              ? loginDto.ecoCommonConfig.companyName
              : userInfo?.deptName ?? ""}
          </Typography>
        </Box>
        {userInfo?.userType === 1 && (
          <Box alignItems="center" classes="mg mt-24">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("header.profile.group")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
              wordBreak="break-word"
            >
              {loginDto.userInfo?.deptName ?? ""}
            </Typography>
          </Box>
        )}
        {userInfo?.userType === 1 && (
          <Box alignItems="center" classes="mg mt-24">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("header.profile.jobTitle")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
              wordBreak="break-word"
            >
              {userInfo?.positionName ?? ""}
            </Typography>
          </Box>
        )}
        {userInfo?.userType === 1 && (
          <Box alignItems="center" classes="mg mt-24">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("header.profile.role")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
              wordBreak="break-word"
            >
              {userInfo?.roleName ?? ""}
            </Typography>
          </Box>
        )}
        {userInfo?.userType === 1 && (
          <Box alignItems="center" classes="mg mt-24">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("signup.email")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
            >
              {userInfo?.email ?? ""}
            </Typography>
          </Box>
        )}
        <Box alignItems="center" classes="mg mt-24">
          <Typography
            type="subtitle2"
            width="120px"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("signup.phone")}
          </Typography>
          <Typography
            type="body2_rg"
            width={"calc(100% - 130px)"}
            classes="mg ml-10"
          >
            {userInfo?.phoneNumber ?? ""}
          </Typography>
        </Box>
        {window.eco.companyName !== "OCI" && userInfo?.userType !== 1 && (
          <Box alignItems="center" classes="mg mt-24">
            <Typography
              type="subtitle2"
              width="120px"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
            >
              {t("header.profile.note")}
            </Typography>
            <Typography
              type="body2_rg"
              width={"calc(100% - 130px)"}
              classes="mg ml-10"
            >
              {userInfo?.etc ?? ""}
            </Typography>
          </Box>
        )}
      </Box>
    );
  };
  /** 사용자 정보 수정 */
  const handleChangeUserInfo = (key: string, value: string) => {
    if (!tempUserInfo) return;
    changeTempUserInfo({ ...tempUserInfo, [key]: value });
  };
  /** 사용자 정보 수정 함수 */
  const handleUpdateMemberInfo = async () => {
    changeMode(mode === "EDIT" ? "VIEW" : "EDIT");
    if (mode === "EDIT" && tempUserInfo) {
      let resp = await changeMemberInfo([
        {
          deptName: tempUserInfo.deptName ?? "",
          etc: tempUserInfo.etc ?? "",
          phoneNumber: tempUserInfo.phoneNumber ?? "",
          status: tempUserInfo.status,
          userId: tempUserInfo.userId,
          userName: tempUserInfo.userName ?? "",
          userType: tempUserInfo.userType,
        },
      ]);
      if (resp.payload) {
        getMembersProfile(loginDto.userInfo.userId);
      }
    }
  };
  /** UI: 프로필 수정 화면 */
  const renderEditPage = () => {
    return (
      <Box direction="column">
        <Typography type="subtitle2" width="120px">
          {t("login.login.userId")}
        </Typography>
        <InputField
          placeholder={" "}
          size="md"
          classes="mg mt-6"
          value={tempUserInfo?.userId}
          disabled
        />
        <span className="mg mt-24">
          <Typography type="subtitle2">{t("header.profile.name")}</Typography>
          <Typography
            type="subtitle2"
            exactColor={getColor("COLOR_TEXT_ERROR")}
          >
            *
          </Typography>
        </span>
        <InputField
          placeholder={t("signup.enterName")}
          size="md"
          classes="mg mt-6"
          onChange={(e) => handleChangeUserInfo("userName", e.target.value)}
          maxLength={128}
          value={tempUserInfo?.userName ?? undefined}
        />
        <span className="mg mt-24">
          <Typography type="subtitle2">
            {userInfo?.userType === 1
              ? t("signup.company")
              : t("header.profile.involvedComany")}
          </Typography>
          <Typography
            type="subtitle2"
            exactColor={getColor("COLOR_TEXT_ERROR")}
          >
            *
          </Typography>
        </span>
        <InputField
          placeholder={t("signup.companyPlaceholder")}
          size="md"
          classes="mg mt-6"
          onChange={(e) => handleChangeUserInfo("deptName", e.target.value)}
          value={tempUserInfo?.deptName ?? undefined}
          maxLength={64}
        />
        <Typography classes="mg mt-24" type="subtitle2">
          {t("signup.phone")}
        </Typography>
        <InputField
          placeholder={t("signup.phonePlaceholder")}
          size="md"
          classes="mg mt-6"
          value={tempUserInfo?.phoneNumber ?? undefined}
          maxLength={16}
          onChange={(e) => {
            if (!/^[0-9-]+$/.test(e.target.value) && e.target.value !== "")
              return;
            handleChangeUserInfo("phoneNumber", e.target.value);
          }}
        />
        {window.eco.companyName !== "OCI" && (
          <Box direction="column">
            <Typography classes="mg mt-24" type="subtitle2">
              {t("header.profile.note")}
            </Typography>
            <InputField
              placeholder={t("header.profile.notePlaceholder")}
              onChange={(e) => handleChangeUserInfo("etc", e.target.value)}
              size="md"
              classes="mg mt-6"
              maxLength={30}
              value={tempUserInfo?.etc ?? undefined}
            />
          </Box>
        )}
        {window.eco.companyName === "OCI" && (
          <Button
            label={t("account.leaveeCo")}
            width={"fit-content"}
            classes="mg mt-40"
            btnStyle="fill"
            type="error"
            onClick={() => changeExtraModal("LEAVE_ECO")}
          />
        )}
      </Box>
    );
  };
  /** 회원 탈퇴 */
  const handleDeleteUser = async () => {
    let resp = await deleteMember(myId);
    if (resp.payload) {
      sessionLogout();
      window.location.href = `${process.env.PUBLIC_URL}/login?toastMsg=account.leaveSuccess`;
    } else {
      toast.toastMsg(nanoid(), t("account.leaveFail"), "error");
    }
  };
  return (
    <Box classes="profileModal-body">
      {extraModal === "LEAVE_ECO" && (
        <Modal
          open
          width={540}
          onClose={() => changeExtraModal("CLOSE")}
          footer={
            <Box>
              <Button
                label={t("common.cancel")}
                btnStyle="fill"
                type="secondary"
                onClick={() => changeExtraModal("CLOSE")}
              />
              <Button
                label={t("account.deleteAccount")}
                btnStyle="fill"
                type="error"
                state="hover"
                onClick={handleDeleteUser}
              />
            </Box>
          }
          title={t("account.leaveeCo")}
          bodyMsg={t("account.leaveeCoMsg")}
        />
      )}
      <Box
        direction="column"
        maxHeight={"calc(100% - 48px)"}
        width={"100%"}
        style={{ paddingInlineEnd: "24px" }}
        classes="mg mb-48 overflow-scroll"
      >
        <Typography type="subtitle2">{t("header.profile.image")}</Typography>
        <Avatar
          name={userInfo?.userName}
          classes="mg mt-10"
          uniqueCode={utilsCommon.getUserColor(userInfo?.userType)}
          size="48"
        />
        <Typography type="subtitle2" classes="mg mt-24">
          {t("header.profile.info")}
        </Typography>
        <span
          className="profileModal-divider"
          style={{ marginBottom: "20px" }}
        />
        {mode === "VIEW" ? renderViewpage() : renderEditPage()}
      </Box>
      {userInfo?.userType !== 1 && (
        <Box classes="mg ml-auto mt-auto">
          {mode === "EDIT" && (
            <Button
              label={t("common.cancel")}
              btnStyle="fill"
              type="secondary"
              width="fit-content"
              onClick={() => {
                changeMode("VIEW");
                changeTempUserInfo(userInfo);
              }}
            />
          )}
          <Button
            label={mode === "EDIT" ? t("common.save") : t("common.edit")}
            btnStyle="fill"
            width="fit-content"
            classes="mg ml-8"
            state={
              !!tempUserInfo?.userId?.trim() &&
              !!tempUserInfo.deptName?.trim() &&
              !!tempUserInfo.userName?.trim()
                ? "default"
                : "disable"
            }
            onClick={handleUpdateMemberInfo}
          />
        </Box>
      )}
    </Box>
  );
};

export default ProfileTab;
